import {Navigate, Outlet} from 'react-router-dom';
import {useAuth} from '../context/AuthContext';
import AuthenticationBackoffice from './AuthenticationBackoffice';
import ContainerBackoffice from './ContainerBackoffice';

export const ProtectedBackoffice = () => {
    const {logged } = useAuth();
    
    if (!logged) {
        return <AuthenticationBackoffice />;
    }

    // if(user.team)
    return (
        <ContainerBackoffice>
            <Outlet />
        </ContainerBackoffice>
    );
};
